// import '../core/lockdown'
import { createRoot } from 'react-dom/client'
import { Route, Router, Switch } from 'wouter'

import { UIGame } from '../game/UIGame'
import { UIEditor } from '../editor/UIEditor'

function Web() {
  return (
    <Router>
      <Switch>
        <Route path='/' component={UIGame} />
        <Route path='/editor' component={UIEditor} />
      </Switch>
    </Router>
  )
}

const root = createRoot(document.getElementById('root'))
root.render(<Web />)
